<template>
    <div id="main">
        <div class="topfocus">
            <p class="focusnum">共关注了{{focusnum}}人</p>
            <el-button type="primary" size="mini" @click="exportData">导出列表</el-button>
            <!-- <p class="sort">默认</p> -->
            <!-- <i class="el-icon-arrow-down"></i> -->
            <!-- <i class="el-icon-sort"></i> -->
        </div>
        <div class="body">
            <div v-for="single in focuslist" :key="single.id" v-show="focuslist.length > 0">
                <HumanCell :isLink="single.role==4" :person="single" @change="changeFocus"></HumanCell>
            </div>
            <el-pagination
                background
                layout="jumper, prev, pager, next, slot, total"
                :total="total"
                :current-page="page"
                @current-change="currentChange"
                @prev-click="prevClick"
                @next-click="nextClick"
                v-show="focuslist.length > 0"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
    import HumanCell from '../common/HumanCell';
    import myUtils from '../common/whatever2excel';
    export default {
        components: {
            HumanCell
        },
        data() {
            return {
                focuslist: [],
                focusnum: '',
                total: 0,
                page: 1
            };
        },
        mounted() {
            this.getfocuslist();
        },
        methods: {
            exportData() {
                let formatList = [];
                this.focuslist.forEach(item => {
                    let obj = {
                        用户id: item.followid,
                        用户姓名: item.username,
                        网址: item.website,
                        描述: item.describe,
                        标签: item.label.map(item => item.lname).toString()
                    };
                    formatList.push(obj);
                });
                myUtils.json2excel(formatList);
            },
            changeFocus() {
                this.$message({
                    message: '操作成功！',
                    type: 'success'
                });
                this.focuslist = [];
                this.getfocuslist();
            },
            getfocuslist() {
                this.httpGet(this.$root.getfollowlist, {
                    page: this.page
                })
                    .then(result => {
                        if (result.count) {
                            this.focuslist.push(...result.list);
                            this.total = Number(result.count);
                        } else {
                            this.focuslist = [];
                            this.total = 0;
                        }
                        this.focusnum = result.count;
                        console.log(result, 99);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            currentChange(page) {
                console.log('currentChange', page);
                this.page = page;
                this.focuslist = [];
                this.getfocuslist();
            },
            prevClick(page) {
                console.log('currentChange1', page);
                this.page = page;
                this.focuslist = [];
                this.getfocuslist();
            },
            nextClick(page) {
                console.log('currentChange2', page);
                this.page = page;
                this.focuslist = [];
                this.getfocuslist();
            }
        }
    };
</script>
<style lang="stylus"  rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    >>>.el-pagination {
        flex-center();
        padding: 20px;
        background: white;
        margin-top 20px
        // width: 100%;
    }

    .topfocus {
        flex-x();

        .focusnum {
            opacity: 0.65;
        }

        .sort {
            opacity: 0.25;
            margin-left: 718px;
        }

        .el-icon-arrow-down {
            margin-left: 4px;
            margin-right: 26px;
        }

        .el-icon-sort {
            width: 10px;
            height: 10px;
            color: #E6E6E8;
        }
    }

    .focuscontent {
        display: flex;
        flex-direction: row;
        width: 880px;
        height: 128px;
        background-color: white;
        border-radius: 8px;

        .avatar {
            border-radius: 50px;
            width: 80px;
            height: 80px;
            margin-top: 24px;
            margin-left: 24px;
        }

        .focusmid {
            display: flex;
            flex-direction: column;
            margin-top: 24px;
            margin-left: 20px;

            .midtop {
                display: flex;
                flex-direction: row;
                align-items: center;

                .followname {
                    font-size: 16px;
                }

                .label {
                    font-size: 12px;
                    color: #000000;
                    opacity: 0.45;
                    margin-left: 16px;
                }
            }

            .midmid {
                display: flex;
                flex-direction: row;
                margin-top: 12px;

                .busname {
                    font-size: 14px;
                    opacity: 0.85;
                }

                .website {
                    margin-left: 16px;
                    font-size: 14px;
                    opacity: 0.85;
                }

                .websiteurl {
                    margin-left: 4px;
                    font-size: 14px;
                    color: #197DFF;
                }
            }

            .describe {
                font-size: 14px;
                opacity: 0.45;
            }
        }

        .buttoncontent {
            display: flex;
            flex-direction: row;
            margin-top: 24px;
            margin-left: 330px;

            .message {
                width: 72px;
                height: 32px;
            }

            .focus {
                width: 72px;
                height: 32px;
            }
        }
    }
</style>
